import React, { Component } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import API from "../../../src/apiService";
import Alert from "../component/Alert";

const SignupSchema = Yup.object().shape({
  name: Yup.string().required("Nama harus diisi"),
});

export default class ModalAddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        id: "",
        name: this.props.roledata?.name ?? '',
        description: this.props.roledata?.description ?? '',
        is_active: 1,
      },
    };
  }

  componentDidUpdate(prevProps, _, __) {
    if (prevProps.roledata !== this.props.roledata) {
      this.setState({ data: this.props.roledata });
    }
  }

  onChange = (event) => {
    const value = event.target.value;
    const object = event.target.name;
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [object]: value,
      },
    }));
  };

  handleSubmit = async () => {
    let data = this.state.data;
    if (data.id > 0) {
      this.putData();
    } else {
      this.postData();
    }
  };

  resetData() {
    this.setState({
      data: {
        id: "",
        name: "",
        is_active: 1,
      },
    });
  }

  postData = async () => {
    let data = this.state.data;
    delete data.id;
    const res = await API.post("config/role/create/", data);
    if (res.code === 200) {
      this.props.onHide();
      this.props.getrole();
      this.resetData();
      Alert("success", "Berhasil menambah role");
    }
  };

  putData = async () => {
    let data = this.state.data;
    const res = await API.put("config/role/update/", data);
    if (res.code === 200) {
      this.props.onHide();
      this.props.getrole();
      this.resetData();
      Alert("success", "Berhasil mengedit role");
    }
  };

  render() {
    return (
      <Modal
        {...this.props}
        aria-labelledby="modal-user"
        onHide={() => {
          this.props.onHide();
          this.resetData();
        }}
      >
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>{this.props.roledata ? 'Edit' : 'Tambah'} Data Role</h3>
          </ModalTitle>
        </ModalHeader>
        <Formik
          enableReinitialize
          initialValues={{
            name: this.state.data.name,
            description: this.state.data.description,
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            this.handleSubmit();
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <ModalBody>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Name
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        placeholder="Name"
                        name={'name'}
                        value={values.name}
                        onChange={this.onChange}
                      />
                      {errors.name && touched.name ? (
                        <div style={{ color: "red" }}>{errors.name}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-5 col-form-label col-form-label-sm"
                  >
                    Description
                  </label>
                  <div className="col-md-7">
                    <div className="row">
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        placeholder="Description"
                        name={'description'}
                        value={values.description}
                        onChange={this.onChange}
                      />
                      {errors.name && touched.name ? (
                        <div style={{ color: "red" }}>{errors.name}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <div className="row">
                  <div className="col-12">
                    <button
                      type="button"
                      onClick={() => {
                        this.props.onHide();
                        this.resetData();
                      }}
                      className="btn btn-outline-secondary"
                    >
                      Batal
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    );
  }
}
